// Imports for external libraries go here.
import React, { FC, useEffect, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { BreadcrumbPage, BreadcrumbModel, BreadcrumbProps } from './Breadcrumb.types';
import { StyledBreadcrumb } from './Breadcrumb.styles';

import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { Icon, Link } from '@marriott/mi-ui-library';
import { useDCADynamicModelAlloy, getDirection } from '../../modules/helpers';

// Use named rather than default exports.
export const Breadcrumb: FC<BreadcrumbProps> = (props: BreadcrumbProps) => {
  /**
   * Fetching the target response
   */
  const mboxParam = props?.model?.mboxParameter;

  /***
   * Makes the call to target if mboxParam is authored
   */
  const targetResponse = useDCADynamicModelAlloy(mboxParam);
  const targetData = targetResponse?.targetData;

  /**
   * Replacing the AEM model data with target data if target Response is present
   */
  const componentValues: BreadcrumbModel = targetData ? targetData : props?.model;

  const [direction, setDirection] = useState(false);
  useEffect(() => {
    setDirection(getDirection());
  }, []);

  return (
    <StyledBreadcrumb className={clsx(props?.model?.styleclass)}>
      <div className="breadcrumb breadcrumb-container">
        <div className={clsx('row px-0 mb-4 mt-3 mr-0 luxury-breadcrumb')}>
          {componentValues &&
            componentValues.breadcrumbPages.map((link: BreadcrumbPage, idx: number) => (
              <>
                <Link
                  linkClassName={clsx(
                    'pb-0 mt-2 t-font-xs breadcrumb-link',
                    link.clickable ? 'text-underline custom_click_track' : ''
                  )}
                  linkHref={link.linkUrl}
                  text={link.linkLabel}
                  ariaLabel={link.linkLabel}
                  key={idx}
                  custom_click_track_value={componentValues.enableTracking ? link.clickTrackValue : ''}
                />
                {componentValues.breadcrumbPages.length - 1 !== idx && (
                  <span className="mx-1 mt-2">
                    <Icon
                      iconClass={clsx('icon-s', direction ? 'icon-arrow-left' : 'icon-arrow-right')}
                      ariaLabel="icon-arrow"
                      key={idx}
                    />
                  </span>
                )}
              </>
            ))}
        </div>
      </div>
    </StyledBreadcrumb>
  );
};

export const BreadcrumbConfig = {
  emptyLabel: 'LuxuryBreadcrumb',
  isEmpty: () => true,
  resourceType: `mi-aem-luxury-spa/components/content/breadcrumb/v1/breadcrumb`,
};
//TODO:Need to fix the lint issue for editable component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BreadcrumbEditable = (props: any) => (
  <div data-testid="luxury-Breadcrumb" data-component-name="m-luxury-Breadcrumb">
    <EditableComponent config={BreadcrumbConfig} {...props}>
      <Breadcrumb {...props} />
    </EditableComponent>
  </div>
);
